import { deleteRequest, getRequest, postRequest } from 'features/common'
import { getClient } from 'features/common/utils/clientParameter'
import { JobClientModel } from './types'
import { buildAuditTags } from 'features/common/utils/buildAuditTags'

export class JobsClient implements JobClientModel {
  constructor(private readonly apiUrl: string) {}

  create(connection, payload) {
    const url = new URL(`${this.apiUrl}/${connection}/job?client=${getClient()}`)
    const workflowId = payload.metadata?.workflowId
    if (workflowId) {
      const params = buildAuditTags({ workflowId })
      for (const key in params) {
        url.searchParams.set(key, params[key])
      }
    }

    return postRequest(url.toString(), payload)
  }

  delete(connection, jobId) {
    return deleteRequest(`${this.apiUrl}/${connection}/job/${jobId}?client=${getClient()}`)
  }

  getStatus(connection, jobId, signal) {
    return getRequest(`${this.apiUrl}/${connection}/job/${jobId}?client=${getClient()}`, { signal })
  }
}
